/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect, useMemo } from "react";
import Breadcrumb from "../common/breadcrumb";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import { adminInstance } from "../../config/axios";
import "../../assets/styles/admin.css";
import Loader from "../loader/loader";
import ParticepentList from "./particepentsList";
import WinnerList from "./winnerList";
import { useLocation } from "react-router-dom";

const GiveawayDetails = () => {
  const [activeTab, setActiveTab] = useState("participants");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    winner: [],
    particepents: [],
  });
  function useQuery() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
  }
  let query = useQuery();
  let giveawayId = query.get("id");

  const getSingleGiveawayData = async (id) => {
    try {
      setLoading(true);
      const response = await adminInstance().get(
        `/api/admin/getGiveawayById/${id}`,
      );
      if (response.data.code === 200) {
        setData({
          winner: response.data.giveAway.winners,
          particepents: response.data.giveAway.participants,
        });
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getSingleGiveawayData(giveawayId);
  }, [giveawayId]);

  return (
    <Fragment>
      {loading && <Loader />}
      <Breadcrumb title="Giveaway List" parent="Giveaway" />
      <Container fluid={true} className="index-page">
        <div className="admin-card">
          <Card>
            <CardHeader>
              <h5>Giveaway</h5>
            </CardHeader>
            <CardBody>
              <div className="tabs">
                <nav className="nav nav-pills flex-column flex-sm-row mt-2 gap10">
                  <button
                    onClick={() => setActiveTab("participants")}
                    className={`flex-sm-fill text-sm-center nav-link navbutton ${activeTab === "participants" ? "active" : ""}`}>
                    Participants
                  </button>
                  <button
                    onClick={() => setActiveTab("winners")}
                    className={`flex-sm-fill text-sm-center nav-link navbutton ${activeTab === "winners" ? "active" : ""}`}>
                    Winners
                  </button>
                </nav>
              </div>
              <div className="clearfix"></div>
              <div
                id="batchDelete"
                className="category-table user-list order-table coupon-list-delete">
                {activeTab === "participants" ? (
                  <ParticepentList myData={data?.particepents} />
                ) : (
                  <WinnerList myData={data?.winner} />
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>
    </Fragment>
  );
};
export default GiveawayDetails;
